import {gql} from "@apollo/client";

export const CHECK_APPOINTMENT_FOR_DATE = gql`
    query CheckAppointmentForDate(
        $cooperationWarehouseId: Long!
        $expectedPickupDate: String!
    ) {
        checkAppointmentForDate(
            cooperationWarehouseId: $cooperationWarehouseId
            expectedPickupDate: $expectedPickupDate
        ) {
            exists
            isStandingPickup
        }
    }
`;

export interface CheckAppointmentForDateVariables {
    cooperationWarehouseId: number;
    expectedPickupDate: string;
}

export interface AppointmentCheckResult {
    exists: boolean;
    isStandingPickup: boolean;
}

export interface CheckAppointmentForDateResponse {
    checkAppointmentForDate: AppointmentCheckResult;
}

